<template>
	<el-checkbox-group v-if="data.setting.isRemote && model"
					   v-model="model[data.fieldId]"
					   :disabled="disabled"
					   @change="checkboxChange">
		<el-checkbox v-for="(item, index) in checkOptions"
					 :key="'checkOptions' + index"
					 :label="item.value"><span
				  	 v-text="item.label"></span></el-checkbox>
	</el-checkbox-group>
	<el-checkbox-group v-else-if="data.setting.isRemote && !model"
					   v-model="data.value"
					   :disabled="disabled"
					   @change="checkboxChange">
		<el-checkbox v-for="(item, index) in checkOptions"
					 :key="'checkOptions' + index"
					 :label="item.value"><span
				  	 v-text="item.label"></span></el-checkbox>
	</el-checkbox-group>
	<el-checkbox-group v-else-if="!data.setting.isRemote && model"
					   v-model="model[data.fieldId]"
					   :disabled="disabled"
					   @change="checkboxChange">
		<el-checkbox v-for="item in checkOptions"
					 :key="item.value"
					 :label="item.value"><span v-text="item.label"></span></el-checkbox>
	</el-checkbox-group>
	<el-checkbox-group v-else
					   v-model="data.value"
					   :disabled="disabled"
					   @change="checkboxChange">
		<el-checkbox v-for="item in checkOptions"
					 :key="item.value"
					 :label="item.value"><span v-text="item.label"></span></el-checkbox>
	</el-checkbox-group>
</template>

<script>
import RemoteMixin from '../../utils/remote-mixin'
import { isHaveKey } from '../../utils/tool'

export default {
	name: 'TpCheckbox',
	mixins: [RemoteMixin],
	inject: [ 'customFormOptions' ],
	props: {
		data: {
			type: Object,
			required: true
		},
		model: Object
	},
	computed: {
		disabled() {
			if (isHaveKey(this.customFormOptions[this.data.fieldId], 'disabled')) {
				return this.customFormOptions[this.data.fieldId].disabled(this.model[this.data.fieldId])
			} else {
				return false
			}
		},

		checkOptions() {
			if (isHaveKey(this.customFormOptions[this.data.fieldId], 'options')) {
				if (this.customFormOptions[this.data.fieldId].options.length > 0 && this.model[this.data.fieldId].length === 0) {
					this.model[this.data.fieldId].push(this.customFormOptions[this.data.fieldId].options[0].value)
				}
				return this.customFormOptions[this.data.fieldId].options
			} else {
				return []
			}
		}
	},
	methods: {
		checkboxChange(val) {
			if (isHaveKey(this.customFormOptions[this.data.fieldId], 'change')) {
				this.customFormOptions[this.data.fieldId].change(val)
			}
		}
	}
}
</script>